<template>
  <template v-if="$isMobile()">
    <div class="px-2 py-1 mb-3" v-if="!loading">
      <div class="d-flex justify-content-between">
        <div>
          <template v-if="!loading && $store.state.vModeWeek == 1 ">
            <div class="small mb-1">Масштаб</div>
            <BtnGroupXMobile :count="3" :name="'xselect'"/>
          </template>

        </div>
        <div>
          <div class="small mb-1">Режим</div>
          <BtnGroupModeMobile :name="'modeselect'"/>
        </div>
      </div>
    </div>
    <BookingTableMobile/>
  </template>
  <template v-else>
    <div class="px-2 py-1 mb-3" v-if="!loading">
      <div class="d-flex justify-content-end">
        <div>
          <div class="small mb-1">Режим</div>
          <BtnGroupModeMobile :name="'modeselect'"/>
        </div>
      </div>
    </div>
    <BookingTable/>
  </template>
  <BottomModal/>
</template>

<script>
import BottomModal from "@/components/BookingTable/BottomModal";
import {dateFormat} from "@/dateFormat";
import {API} from "@/getapi";
import BookingTable from "@/components/BookingTable/BookingTable";

export default {
  name: "MyApp",
  components: {BookingTable,BottomModal},
  inject: [
    'URL_GETWEEK',
  ],
  provide() {
    return {
      searchData:this.searchData,
      // сколько процентов вычитается при возврате суммы за бронь,когда просрочка по времени возврата
      percentRetention: 50,
      timeSlideData: this.timeSlideData
    }
  },
  data() {
    return {
      loading: true,
      timeSlideData: {
        1: "10:00",
        2: "10:30",
        3: "11:00",
        4: "11:30",
        5: "12:00",
        6: "12:30",
        7: "13:00",
        8: "13:30",
        9: "14:00",
        10: "14:30",
        11: "15:00",
        12: "15:30",
        13: "16:00",
        14: "16:30",
        15: "17:00",
        16: "17:30",
        17: "18:00",
        18: "18:30",
        19: "19:00",
        20: "19:30",
        21: "20:00",
        22: "20:30",
        23: "21:00",
        24: "21:30",
        25: "22:00"
      },
      searchData: {
        'officeId': 26,
        'cabinetId': 26,
        'date': "",
      },
    }
  },
  beforeUnmount() {
    this.$emitter.off('bookingDone')
  },
  created() {
    this.searchData.officeId = this.$store.state.cabData.officeId
    this.searchData.cabinetId = this.$store.state.cabData.cabinetId
    // console.log('CREATED',this.searchData)

    this.$emitter.on('bookingDone', () => {
      // console.log('bookingDone in created')
      this.getDataFromAPi()
    })

    this.$emitter.on('prevWeek', () => {
      if (!this.$store.state.loading) {
        let nowDate = dateFormat.formatDate(dateFormat.getDateNowWithTimeZone())
        let currentDate = new Date(this.searchData.date)

        if (dateFormat.compare(this.searchData.date, nowDate) == '>') {
          currentDate.setDate(currentDate.getDate() - 7);
          this.searchData.date = dateFormat.formatDate(currentDate)
          // console.log('prevWeek',this.searchData.date)
          this.$store.dispatch('selector/resetSelector')
          this.getDataFromAPi()
        }
      }
    })

    this.$emitter.on('nextWeek', () => {
      if (!this.$store.state.loading) {
        let currentDate = new Date(this.searchData.date)
        currentDate.setDate(currentDate.getDate() + 7);
        this.searchData.date = dateFormat.formatDate(currentDate)
        // console.log('nextWeek',this.searchData.date)
        this.$store.dispatch('selector/resetSelector')
        this.getDataFromAPi()
      }
    })

    this.start()
  },
  computed: {
  },
  methods: {
    start() {

      let currentDate = dateFormat.getDateNowWithTimeZone()
      // let monday = dateFormat.getMonday(currentDate);
      // this.searchData.date = dateFormat.formatDate(monday)
      this.searchData.date = dateFormat.formatDate(currentDate)
      this.getDataFromAPi()
    },
    isSet(val) {
      return typeof val !== 'undefined'
    },

    getDataFromAPi() {
      // console.log('ALIAS ')
      if (!this.$store.state.loading) {

        this.$store.commit('setLoading', true, {root: true})
        // console.log('this.searchData ', this.searchData)
        let _this = this;
        API.get(this.URL_GETWEEK, this.searchData).then(({data}) => {

          if (data.isOK) {
            console.log(data.result);
            // _this.$store.dispatch('selector/resetSelector')
            _this.$store.commit('setLoading', false, {root: true});
            _this.$store.dispatch('setData', data.result);
            this.loading = false

          } else {
            console.error("Error:", data.errors)
            _this.$store.commit('setLoading', false, {root: true});
          }
        }).catch((err) => {
          _this.$store.commit('setLoading', false, {root: true});
          API.catch(err)
        })
      } else {
        console.log('Busy. Loading...')
      }
    }
  }
}
</script>

<style >
.Vue-Toastification__toast.custom-toast-class {
  min-height: 43px;
  padding: 10px 24px;
}

.Vue-Toastification__toast--info.custom-toast-class {
  background-color: #E07A5F;
}

</style>
<script setup>
import BookingTableMobile from "@/components/BookingTableMobile/BookingTableMobile.vue";
import BtnGroupXMobile from "@/components/BookingTableMobile/BtnGroupXMobile.vue";
import BtnGroupModeMobile from "@/components/BookingTableMobile/BtnGroupModeMobile.vue";
</script>
<script setup>
</script>